// Servicio de beneficios
import { apiClient } from './api';
import { API_ENDPOINTS, API_BASE_URL } from '../config';

export const benefitsService = {
  /**
   * Obtener todos los beneficios activos
   * @returns {Promise<Object>} Lista de beneficios activos
   */
  async getAll() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BENEFITS || `${API_BASE_URL}/api/benefits`);
      return response;
    } catch (error) {
      console.error('Error obteniendo beneficios:', error);
      throw error;
    }
  },
};

